module.exports = __webpack_public_path__ + "static/media/image_13.c5032070.jpg";